import { buildGradientCard } from '../../utils/listSummaryUtils';

function isDieselStockRow(row) {
    const name = String(row?.product_name || '').toLowerCase();
    const unit = String(row?.unit || '').toLowerCase();
    return name.includes('diesel')
        || unit.includes('ltr')
        || unit.includes('liter')
        || unit.includes('litre')
        || unit.includes('kiloliter');
}

export function buildDieselStockSummaryCards(stockByProduct, options = {}) {
    const dieselProductIds = (options.dieselProductIds || []).map(String).filter(Boolean);
    const idSet = new Set(dieselProductIds);

    let purchase = 0;
    let issued = 0;

    Object.values(stockByProduct || {}).forEach((row) => {
        if (!row) return;
        const id = String(row.product_id);
        const include = idSet.size ? idSet.has(id) : isDieselStockRow(row);
        if (!include) return;
        purchase += Number(row.received_qty) || 0;
        issued += Number(row.consumed_qty) || 0;
    });

    // Always derive available from the same Purchase / Issued totals.
    const available = Number((purchase - issued).toFixed(3));

    return [
        buildGradientCard('Purchase', purchase.toFixed(3), 'blue'),
        buildGradientCard('Issued', issued.toFixed(3), 'teal'),
        buildGradientCard('Stock Available', available.toFixed(3), 'purple'),
    ];
}
